const problems = [
  {
    icon: 'ri-search-line',
    title: 'Too much scattered information online',
    description: 'You search for pregnancy advice and get flooded with contradicting articles, forums, and videos. No single trusted source.',
    color: 'rose'
  },
  {
    icon: 'ri-hospital-line',
    title: 'Difficult to choose the right hospital',
    description: 'Should you go to a government hospital or private? What about NICU facilities? Costs are never clear until it\'s too late.',
    color: 'orange'
  },
  {
    icon: 'ri-syringe-line',
    title: 'Important vaccines & checkups are missed',
    description: 'Vaccine schedules are complex. Without a reminder system, critical immunizations for your baby often get delayed or forgotten.',
    color: 'amber'
  },
  {
    icon: 'ri-apps-line',
    title: 'No single platform for complete care',
    description: 'Pregnancy apps, hospital websites, government portals everything is separate. No one connects it all for you.',
    color: 'red'
  }
];

const colorMap: Record<string, string> = {
  rose: 'bg-rose-50 border-rose-100 text-rose-600',
  orange: 'bg-orange-50 border-orange-100 text-orange-600',
  amber: 'bg-amber-50 border-amber-100 text-amber-600',
  red: 'bg-red-50 border-red-100 text-red-600'
};

export default function Problem() {
  return (
    <section id="problem" className="py-20 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-rose-50 border border-rose-100 rounded-full mb-5">
            <i className="ri-error-warning-line text-rose-500"></i>
            <span className="text-sm font-semibold text-rose-600">The Real Problem</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-5 leading-tight">
            Pregnancy &amp; Baby Care Should{' '}
            <span className="text-rose-500">Not Be Confusing</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Becoming a parent is one of life's most beautiful journeys, but the healthcare system makes it unnecessarily complicated. Here's what every family faces.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {problems.map((problem, index) => (
            <div
              key={index}
              className={`rounded-2xl p-6 border ${colorMap[problem.color].split(' ').slice(0,2).join(' ')} ${colorMap[problem.color].split(' ')[1]} hover:-translate-y-1 transition-transform`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 ${colorMap[problem.color].split(' ').slice(0,2).join(' ')} border ${colorMap[problem.color].split(' ')[1]}`}>
                <i className={`${problem.icon} text-2xl ${colorMap[problem.color].split(' ')[2]}`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2 leading-snug">{problem.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{problem.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-teal-50 to-sky-50 border border-teal-100 rounded-2xl p-6 sm:p-8 flex flex-col sm:flex-row items-center gap-5">
          <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-2xl shrink-0">
            <i className="ri-lightbulb-flash-line text-3xl text-teal-600"></i>
          </div>
          <div>
            <p className="text-lg font-bold text-gray-900 mb-1">There has to be a better way.</p>
            <p className="text-base text-gray-600">
              That's exactly why <strong className="text-teal-700">MomsFirstCare</strong> exists one platform that guides you through every step of pregnancy and baby care, so you never feel lost or alone.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
